import DataGrid, { Column, ColumnFixing, FilterRow, HeaderFilter, Paging, Scrolling } from "devextreme-react/data-grid";
import { Box } from "../../../../components";
import { useDocumentExpired } from "../../hooks/documents/use-document-expired";
import { DocumentDataGridItem } from "./document-datagrid-item";
import { useSearchParams } from "../../../../hook/use-search-params";
import { Spin } from "antd";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";

export const DocumentExpiredList = () => {
  const { data, isLoading } = useDocumentExpired();
  const { searchParams } = useSearchParams();
  const statusQuery = searchParams.get("status");
  const history = useHistory();

  const goToDetail = (item: any, action: string = "", mode: string = "", templateId: any = null) => {
    let itemId = item?.docWorkingId;

    if (!itemId) {
      itemId = 0;
    }
    let filters = [];

    if (action !== null && action !== "") filters.push(`action=${action}`);

    if (mode !== "") {
      filters.push(`mode=${mode}`);
    }

    filters.push(`status=${statusQuery}`);

    if (item?.id) {
      filters.push(`fileId=${item.fileId}`);
    }

    if (!item?.IsCustomEditor) {
      filters.push(`action=info`);
    }

    let filterQuery = "";
    if (filters.length > 0) {
      filterQuery = `?${filters.join("&")}`;
    }
    history.push(Routes.documentDetail.path.replace(":id", `${itemId}${filterQuery}`));
  };

  if (isLoading) return <Spin />;

  return (
    <Box title="Tài liệu lỗi thời">
      <div className="d-flex justify-content-end pb-2">
        <p className="font-weight-bold">
          Tổng cộng:{" "}
          <span className="text-primary" style={{ fontSize: "22px" }}>
            {data?.data?.length}
          </span>{" "}
          tài liệu
        </p>
      </div>
      <div className="w-full overflow-auto">
        <DataGrid
          id="grid__title-container"
          dataSource={data?.data}
          noDataText="Không tìm thấy tài liệu"
          showBorders={true}
          rowAlternationEnabled={true}
          wordWrapEnabled={true}
          dataRowRender={(datRow) => (
            <DocumentDataGridItem
              document={datRow.data}
              statusView={statusQuery}
              isShowAction={false}
              isShowCheckColumn={false}
              goToDetail={goToDetail}
              wordWrapEnabled={true}
              filterExpired={true}
              listId={"publish"}
            />
          )}
        >
          <Scrolling mode="standard" />
          <ColumnFixing enabled={true} />
          <FilterRow visible={true} applyFilter={true} />
          <HeaderFilter visible={true} />
          <Paging defaultPageSize={20} />
          <Column
            fixed={true}
            fixedPosition="left"
            dataField="Title"
            caption="Tên tài liệu"
            minWidth={200}
            allowFixing={true}
            allowHeaderFiltering={false}
          />
          <Column dataField="docCode" caption="Mã tài liệu" allowHeaderFiltering={false} alignment="left" />
          <Column dataField="docType" caption="Loại tài liệu" />
          <Column dataField="docStatus" caption="Tình trạng" />
          <Column
            dataField="createdDateTime"
            dataType="date"
            selectedFilterOperation="between"
            caption="Ngày hiệu lực"
          />
          <Column
            dataField="docPublishViewVersion"
            caption="Lần ban hành"
            dataType="number"
            allowHeaderFiltering={false}
            width={80}
          />
          <Column
            dataField="docEditionVersion"
            caption="Lần sửa đổi"
            dataType="number"
            allowHeaderFiltering={false}
            width={80}
          />
          <Column
            dataField="createdDateTime"
            caption="Thời gian khởi tạo"
            dataType="date"
            selectedFilterOperation="between"
            allowHeaderFiltering={false}
          />
          <Column dataField="createdUser" caption="Người khởi tạo" dataType="string" allowHeaderFiltering={false} />
          <Column
            dataField="lastModifiedDateTime"
            caption="Thời gian cập nhật"
            dataType="date" 
            selectedFilterOperation="between"
            allowHeaderFiltering={false}
            sortOrder="desc"
          />
          <Column dataField="modifiedUser" caption="Người cập nhật" dataType="string" allowHeaderFiltering={false} />
          <Column dataField="tags" caption="Chủ đề" allowHeaderFiltering={false}>
            <HeaderFilter />
          </Column>
          {/* <Column name="actions" fixed={true} fixedPosition="right" width={150} alignment="center" /> */}
        </DataGrid>
      </div>
    </Box>
  );
};
